import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Hero from '../components/home/Hero';
import ServicesPreview from '../components/home/ServicesPreview';
import AboutPreview from '../components/home/AboutPreview';
import Clients from '../components/home/Clients';
import ContactCTA from '../components/home/ContactCTA';

const Home = () => {
    const { t, i18n } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('hero.title')} | {t('nav.home')}</title>
                <meta name="description" content={t('hero.subtitle')} />
                <meta property="og:title" content={t('hero.title')} />
                <meta property="og:description" content={t('hero.subtitle')} />
                <html lang={i18n.language} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} />
            </Helmet>

            <main>
                <Hero />
                <ServicesPreview />
                <AboutPreview />
                <Clients />
                <ContactCTA />
            </main>
        </>
    );
};

export default Home;
